import Immutable from 'immutable';

const LOAD = 'owner/LOAD';
const LOAD_SUCCESS = 'owner/LOAD_SUCCESS';
const LOAD_FAIL = 'owner/LOAD_FAIL';

const LOAD_ADD_SUCCESS = 'owner/LOAD_ADD_SUCCESS';
const LOAD_OWNER_SUCCES = 'owner/LOAD_OWNER_SUCCES';
const CREATE_NEW = 'owner/CREATE_NEW';

const LOAD_OWNER_INFO_FAIL = 'owner/LOAD_OWNER_INFO_FAIL';
const LOAD_OWNER_INFO_SUCCESS = 'owner/LOAD_OWNER_INFO_SUCCESS';

const initialState = Immutable.fromJS({
  loading: false,
  errorMessage: null,
  owners: [],  
  owner: null,
  ownersInfo: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true);

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
        return state
          .set('loading', false)
          .set('owners', action.result);

    case LOAD_ADD_SUCCESS:
        return state
          .set('loading', false)
          .set('Owner', action.result);

    case LOAD_OWNER_SUCCES:
        return state
          .set('owner', action.result);

    case CREATE_NEW:
        return state
          .set('owner', action.result);

    case LOAD_OWNER_INFO_SUCCESS:
      return state
        .set('loading', false)
        .set('ownersInfo', action.result);

  case LOAD_OWNER_INFO_FAIL:
    return state
      .set('loading', false)
      .set('errorMessage', action.errorMessage);

    default:
        return state;
  }
}

export const getOwners = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/owner/ownerAll/`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getActiveOwners = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/owner/ownerActiveAll`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const creatNew = () => async(dispatch) => {
  dispatch({ type: CREATE_NEW, result: { active: 1 } })
}

export const addOwner = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/owner', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateOwner = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/owner', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }  
    const owners = getState().get('owner').get('owners');
    const index = owners.findIndex(owner => owner.id === data.id);

    owners[index] = Object.assign({}, owners[index], {
      ownerFirst: data.ownerFirst,
      ownerlast: data.ownerlast,
      ownership_Percent: data.ownership_Percent,
      bank_account: data.bank_account,
      tax_ID: data.tax_ID,
      id: data.id
    });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteOwner = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/owner', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const owners = getState().get('owner').get('owners');
    const index = owners.findIndex(owner => owner.id === data.id);
    owners.splice(index, 1);
    
    dispatch({ type: LOAD_SUCCESS, result: owners });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};
export const deleteFarmOwner = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/owner/farmOwner', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};
export const getOwnerById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/owner/ownerGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    res = Object.assign({}, res, {
      active: res.active === '1',
      portal_access: res.portal_access === '1'
    });

    dispatch({ type: LOAD_OWNER_SUCCES, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getOwnerByFarmId = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/owner/ownerGetByFarmId/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addNewOwner = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/owner/newOwnerCreate', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateNewOwner = (data, prevId) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/owner/newOwnerUpdate', { data, prevId });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const ownerInfoReport = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/owner/owner-info-reports');
    if (res.message) {
      dispatch({ type: LOAD_OWNER_INFO_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_OWNER_INFO_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_OWNER_INFO_FAIL, errorMessage: error });
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/owner.js